import React from "react";

import Analytics from "helpers/analytics";
import { useHistory } from "react-router";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

function Toolbar(props) {
  const history = useHistory();
  const { location } = props;

  let prevPath = "";
  if (location.state !== undefined) {
    prevPath = location.state.prevPath;
  }

  let backText = "Browse More Videos";

  if (prevPath.startsWith("/licensing/search")) {
    backText = "Back to Search";
  }

  const onClickBack = () => {
    Analytics.track("BackToSearch", {
      category: "LP-VideoDetail"
    });

    history.goBack();
  };

  return (
    <div className="see-more-videos">
      <button onClick={onClickBack}>
        <KeyboardArrowLeftIcon />
        <span>{backText}</span>
      </button>
    </div>
  );
}

export default Toolbar;
